"use client";
import { Tooltip } from "@clover-web-lib-sprout/tooltip";

export const Surcharge = ({
  isTimeSlot,
  surchargeRate,
  placement = "bottom",
}: any) => {
  const paddingRight = isTimeSlot ? "pr-5" : "";
  const surchargeRoundRate = Math.round(surchargeRate * 10000) / 100;
  const surchargeText = `${surchargeRoundRate}% surcharge on credit card transactions`;
  const tooltipText = `Payments made with a credit card will incur a ${surchargeRoundRate}% surcharge fee. All
      other payment types will not incur additional fees.`;

  return (
    <Tooltip
      content={tooltipText}
      label="surcharge-tooltip"
      placement={placement}
      shouldNotWrap
      id={"surcharge-tooltip"}
    >
      <div
        className="relative cursor-pointer"
        role="button"
        aria-label="toolTip"
        tabIndex={0}
      >
        <label
          className={`text-[14px] font-medium text-black px-1 mb-2 cursor-pointer underline decoration-dashed ${paddingRight} hover:decoration-solid`}
        >
          {surchargeText}
        </label>
      </div>
    </Tooltip>
  );
};
